import { useEffect, useRef, useState } from "react";
import {
  APPLIED,
  APPROVED,
  UNDER_CONSTRUCTION,
  CONSTRUCTED,
} from "./constants";

/**
 * @todo handle errors
 */

export default function useWeaveSearch(query) {
  const [results, setResults] = useState([]);
  const abortRef = useRef();

  useEffect(() => {
    async function fetchResults() {
      if (query === '') {
        setResults([]);
        return;
      }

      /**
       * if there's a previously running fetch, abort that sh*t
       */
      if (abortRef.current !== undefined) {
        abortRef.current.abort();
      }

      /**
       * Create a new abortion controller
       */
      const controller = new AbortController();
      const { signal } = controller;
      abortRef.current = controller;

      /**
       * Run the query
       */
      const url = `https://weave-proxy-api-v2.au-s1.cloudhub.io/weave/v1/index/search?query=${encodeURIComponent(
        query
      )}&start=0&limit=10&indexes=idx_developmentfootprint&indexes=idx_property_bb&indexes=idx_property_occ&type=EXACT&crs=EPSG%3A4326`;
      const headers = {
        Authorization: `Basic ${btoa(
          "20dfb9adc81b4a49911c683b661f559c:93cf2E087f4f4768BF4D77EaA9e6A68C"
        )}`,
      };
      try {
        const response = await fetch(url, { signal, headers }).then((res) =>
          res.json()
        );
        if (response.results) {
        //  console.log(response)
          const applied = response.results.filter(
            (d) => d.display2 === APPLIED
          );
          const approved = response.results.filter(
            (d) => d.display2 === APPROVED
          );
          const constructing = response.results.filter(
            (d) => d.display2 === UNDER_CONSTRUCTION
          );
          const completed = response.results.filter(
            (d) => d.display2 === CONSTRUCTED
          );
          const others = response.results.filter(
            (d) => d.entity === "lyr_property"
          );
        //  console.log(response.results)
         // console.log(others)
         /* const others = response.results.filter(
            (d) => d.entity === "idx_property_bb" || d.entity === "idx_property_occ"
          );*/
         /* console.log([
            ...applied,
            ...approved,
            ...constructing,
            ...completed,
            ...others,
          ])*/
          setResults([
            ...applied,
            ...approved,
            ...constructing,
            ...completed,
            ...others,
          ]);
        }
      } catch (error) {
        console.log(error)
        setResults([]);
      }
    }
    fetchResults();
  }, [query]);

  return { results };
}
